import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ListSubject() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [subjectCount, setSubjectCount] = useState(0);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords(currentPage, perPage);
  }, [currentPage, perPage]);

  const fetchRecords = async (page, perPage) => {
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${apiUrl}/api/subject?skip=${(page - 1) * perPage}&take=${perPage}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setRecords(response.data.subjects);
      setTotalRows(response.data.count);
      setSubjectCount(response.data.count);
    } catch (error) {
      console.error('Error fetching records:', error);
      if (error.response?.status === 401) navigate('/');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this subject?')) {
      const token = localStorage.getItem('token');
      try {
        await axios.delete(`${apiUrl}/api/subject/${id}`, {
          headers: {
            Authorization: token,
          },
        });
        setRecords(records.filter((record) => record.id !== id));
        toast.success('Subject deleted successfully');
      } catch (error) {
        console.error('Error deleting subject:', error);
        toast.error(
          error.response?.data?.message || 'Failed to delete subject'
        );
        if (error.response?.status === 401) navigate('/');
      }
    }
  };

  const formatSubjects = (subjects) => {
    if (Array.isArray(subjects)) {
      return (
        <div className="d-flex flex-wrap gap-2">
          {subjects.map((subject, index) => (
            <span
              key={index}
              className="badge bg-secondary p-2 text-wrap text-start"
            >
              <i className="bi bi-journal-album"></i>&nbsp;
              {subject.objectiveName}
              {index < subjects.length - 1 && ', '}
            </span>
          ))}
        </div>
      );
    }
    return <span className="badge bg-secondary">{subjects}</span>;
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: '50px',
      center: true,
    },
    {
      name: 'Subject Code',
      selector: (row) => row.subjectCode,
      sortable: true,
      width: '125px',
      center: 'true',
    },
    {
      name: ' Subject Name',
      selector: (row) => row.name,
      sortable: true,
      width: '250px',
    },
    {
      name: 'Subject Objectives',
      selector: (row) => row.subjectObjectives,
      cell: (row) => formatSubjects(row.subjectObjectives),
      wrap: true,
      grow: 2,
    },
    {
      name: 'Actions',
      width: '115px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            onClick={() => navigate('/EditSubject', { state: { id: row.id } })}
            className="btn btn-primary btn-sm mx-2"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Edit Subject"
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(row.id)}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Delete Subject"
          >
            <i className="bi bi-trash3-fill"></i>
          </button>
        </div>
      ),
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac2="active" dr="true">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  View Subject ({subjectCount})
                </li>
              </ol>
            </nav>
          </div>
          <hr className="mb-0" />
          <div className="row">
            <div className="container">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    name="totalMarks"
                    placeholder="Search"
                    title="Search within table"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => navigate('/AddSubject')}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Add New Subject"
                  >
                    <i className="bi bi-plus-square"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records.filter((record) =>
                    record.name.toLowerCase().includes(searchTerm.toLowerCase())
                  )}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerPageChange}
                  onChangePage={handlePageChange}
                  className="custom-table"
                />
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
            </div>
          </div>
        </AdminLayout>
        <Tooltip id="my-tooltip" />
      </main>
    </div>
  );
}
